import { AspectRatioBox } from '@smartgift/frontend-toolkit';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

export function BannerSkeleton(props) {
  return (
    <AspectRatioBox ratio="9.3:1.1">
      <StyledContentLoader
        speed={2}
        width="100%"
        height="100%"
        viewBox="0 0 100% 100%"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="0" y="0" rx="2" ry="2" width="100%" height="100%" />
      </StyledContentLoader>
    </AspectRatioBox>
  );
}
